import React from 'react'
import AgbEN from './agb/AgbEN'
import AgbDE from './agb/AgbDE'
import useLanguage from '@hooks/useLanguage.hook'

const AGB = () => {
    const [lng] = useLanguage()

    return <div>{lng.includes('en') ? <AgbEN /> : <AgbDE />}</div>
}

export default AGB
